import React, { useContext, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { LayoutType, ListArtifactItems, SKListArtifact, ContentState } from "../../../models/SKArtifact";
import { EditLayoutText } from "./EditLayoutText";
import { LayoutTextInput } from "./container/components/LayoutTextInput";
import { AddTextField } from "./container/components/AddTextField";

export const AddLayoutText = () => {
  const { contentData, artifactId, updateContentData, loading, saveData, isEditable, isModerator } = useContext(CreateArtifactContext);
  const [isValidForm, setIsValidForm] = useState(false);
  const [error, setError] = useState<string>("");
  const [itemName, setItemName] = useState("");
  const [itemDescription, setItemDescription] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [items, setItems] = useState<ListArtifactItems[]>([]);
  var charAllowed = 150;
  var cdescriptionCarAllowed = 300;
  var [isValidInput, setIsValidInput] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [editItem, setEditItem] = useState<ListArtifactItems>();

  const schema = Yup.object().shape({
    listTitle: Yup.string().required(),
    listDescription: Yup.string().required(),
  });

  useEffect(() => {
    const validate = async () => {
      try {
        await schema.validate(contentData, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate();
  }, [contentData, schema]);

  useEffect(() => {
    if ((contentData as SKListArtifact).listItems != null) {
      setItems((contentData as SKListArtifact).listItems);
    }
  }, []);

  useEffect(() => {
    setIsValidInput(itemName.length >= 3 && itemDescription.length >= 3);
  }, [itemName, itemDescription]);

  const handleSave = async () => {
    setIsValidInput(false);
    try {
      const newItem: ListArtifactItems = {
        id: new Date().toISOString(),
        listTitle: itemName,
        listDescription: itemDescription,
        listImage: "",
        listURL: "",
      };

      if (newItem) {
        const updatedItems = [...items, newItem];
        setItems(updatedItems);
        updateContentData({ listItems: updatedItems });
      }

      setIsValidInput(false);
      setItemName("");
      setItemDescription("");
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  /*   const handleSave = async () => {
    setIsValidInput(false);
    const newItem: ListArtifactItems = {
      id: new Date().toISOString(),
      listTitle: itemName,
      listDescription: itemDescription,
      listImage: "",
      listURL: "",
    };
    setItems([...items, newItem]);
    updateContentData({ listItems: items });
    setItemName("");
    setItemDescription("");
  }; */

  const handleRemoveItem = (id: string) => {
    const updatedItems = items.filter(item => item.id !== id);
    setItems(updatedItems);
  };

  const getItemById = (id: string): ListArtifactItems | undefined => {
    return items.find(item => item.id === id);
  };

  const editItemPopup = (id: string) => {
    setEditItem(getItemById(id));
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const savePopup = async (name: string, description: string) => {
    if (editItem) {
      const updatedItem = {
        ...editItem,
        listTitle: name,
        listDescription: description,
      };
      const updatedItems = items.map(item => (item.id === editItem.id ? updatedItem : item));
      setItems(updatedItems);
      await updateContentData({ listItems: updatedItems });
      closePopup();
    }
  };

  return (
    <>
      <div className="flex flex-col gap-[15px] max-w-[480px]">
        {isEditable && !isModerator && (
          <>
            <div>
              <AddTextField
                name={"listName"}
                title={"Add List Item"}
                note={"Type or paste the item text."}
                placeholder={"List Item"}
                index={1}
                charAllowed={150}
                value={itemName}
                onChange={async e => {
                  setItemName(e.target.value);
                }}
                disabled={!isEditable}
              />
            </div>
            <div className="relative w-full min-w-[200px]">
              <div className="flex rectangle-class">
                <textarea
                  name="itemDescription"
                  className="rectangle-text"
                  style={{ minHeight: `${110}px` }}
                  placeholder="Item Description"
                  ref={textareaRef}
                  value={itemDescription}
                  onChange={async e => {
                    setItemDescription(e.target.value);
                  }}
                  maxLength={cdescriptionCarAllowed}
                  rows={5}
                  cols={30}
                ></textarea>
              </div>
              {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
              {!error && <div className="remaining-characters">{cdescriptionCarAllowed - (itemDescription.length ?? 0)} characters remaining.</div>}
            </div>
            <div className="flex justify-end w-full">
              <button
                className={
                  (isEditable && isValidInput ? " bg-black " : " bg-gray-400  disabled-link ") +
                  "flex items-center justify-center px-3 py-1 text-sm font-normal text-center text-white rounded-lg"
                }
                onClick={handleSave}
              >
                ADD
              </button>
            </div>
          </>
        )}

        <div className="relative w-full min-w-[200px]">
          <div className="flex items-center">
            {isEditable && !isModerator && <span className="content_count">2</span>}
            <span className="content_title">List Items Added</span>
          </div>
          <div className="notes-class-content">Items you add show up here, you can edit, reorder, and delete.</div>
        </div>
        <LayoutTextInput items={items} editItemPopup={editItemPopup} handleRemoveItem={handleRemoveItem} />

        {isEditable && isPopupOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
            <div className="relative p-6 bg-white rounded-lg shadow-lg w-96">
              <EditLayoutText
                isOpen={isPopupOpen}
                onClose={closePopup}
                onSave={savePopup}
                itemName={editItem?.listTitle}
                description={editItem?.listDescription}
                onChange={async e => {
                  //handleRemoveItem(editItem!.listId);
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
